import { render, staticRenderFns } from "./DeliveryOrders.vue?vue&type=template&id=2222e0f1"
import script from "./DeliveryOrders.vue?vue&type=script&lang=js"
export * from "./DeliveryOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports